import type { BlockProps } from "./blocks/registry";
import MenuListeSection from "../design-system/organisms/MenuListeSection";
import { Heading } from "../design-system/atoms/Heading";

type MenuListeData = {
  id?: number | string;
  documentId?: string;
  title: string;
};


const dataMenu = [
		{
			id: 1,
			image: `https://site-lms.fra1.digitaloceanspaces.com/gamme_plaisir_1ebad6296c.png`,
			icon: `https://site-lms.fra1.digitaloceanspaces.com/plaisir_f41791c972.svg`,
			title: "Gamme Plaisir",
			subtitle: "Pour un repas comme à la maison",
			description: "Votre menu avec entrée, plat et garniture, fromage ou dessert",
			ctaLabel: "Commander",
			ctaLink: "/gamme-plaisir",
			price: { main: "à partir de 12,80€ TTC", sub: "(11,64€ HT)", extra: "9,64€ après aides fiscales" },
			style: "",
		},
		{
			id: 2,
			image: `https://site-lms.fra1.digitaloceanspaces.com/about_img_2_9c8c4ab7ff.png`,
			icon: `https://site-lms.fra1.digitaloceanspaces.com/plaisir2_0d2c11eff2.svg`,
			title: "Gamme Gourmet",
			subtitle: "Pour un repas comme chez le traiteur",
			description: "Votre menu avec entrée, plat et garniture, fromage et dessert",
			ctaLabel: "Commander",
			ctaLink: "/gamme-gourmet",
			style: "blur-sm select-none",
			price: { main: "à partir de 12,80€ TTC", sub: "(11,64€ HT)", extra: "9,64€ après aides fiscales" },
		},


	];


export default function MenuListe({ data }: BlockProps<MenuListeData>) {

  return (
	<section key={data.documentId} className="py-10 lms-mobile">
		<Heading as="h2" className="text-4xl lg:text-[44px] font-bold text-text text-center ">
                    {data.title.split(" ").map((word, i) =>
                        i === 1 ? (
                            <span key={i} className="text-secondary">
                                {word}{" "}
                            </span>
                        ) : (
                            word + " "
                        )
                    )}
                </Heading>
		<MenuListeSection menus={dataMenu}  />
	</section>
	
  ) ;
}
